import jwtDecode, { JwtPayload } from 'jwt-decode'
import React from 'react'
import { AuthInformation } from '../models/api'
import * as LocalStorage from './localStorage'

interface UseAuth extends Partial<AuthenticatedInformation> {
  storeLogin(token: string): Promise<void>
  logout(): void
  getAuthInformation(): AuthInformation | null
}

export interface AuthenticatedInformation {
  authInformation: AuthInformation
}

type AuthTuple = [
  Partial<AuthenticatedInformation>,
  React.Dispatch<React.SetStateAction<Partial<AuthenticatedInformation>>>,
]

export const AuthContext = React.createContext<AuthTuple>([{}, (): void => undefined])

export function useAuth(): UseAuth {
  const [auth, setAuth] = React.useContext(AuthContext)

  const getAuthInformation = (): AuthInformation | null => {
    return LocalStorage.getAuthInformation()
  }

  const storeLogin = async (token: string): Promise<void> => {
    const payload = jwtDecode<JwtCustomPayload>(token)
    const authInformation: AuthInformation = {
      token: token,
      ...payload,
    }

    setAuth({
      authInformation,
    })
    LocalStorage.setAuthInformation(authInformation)
  }

  const logout = (): void => {
    LocalStorage.logout()
    setAuth({})
  }

  return {
    ...auth,
    getAuthInformation,
    logout,
    storeLogin,
  }
}

interface JwtCustomPayload extends JwtPayload {
  userId: number
  jurisdictionId?: number
}
